function helperGetUTCDateTime (resMaps) {
  return Date.UTC(resMaps.y, resMaps.M || 0, resMaps.d || 1, resMaps.H || 0, resMaps.m || 0, resMaps.s || 0, resMaps.S || 0)
}

module.exports = helperGetUTCDateTime



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperGetUTCDateTime.js
// module id = Lofr
// module chunks = 137